export const invitationForwardInitialState = {
	invitations: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
